import React, { useMemo, useState } from 'react';
import { useGetLikeFoodQuery } from '../../redux/services/foods/foodAPI ';
import { useGetRoomQuery } from '../../redux/services/rooms/roomAPI';
import { useGetFoodQuery } from '../../redux/services/foods/foodAPI ';
import Food from '../../components/Food';
import Room from '../../components/Room';

function Favorites({ user }) {
  const { data: rooms } = useGetRoomQuery();
  const { data: foodLikes } = useGetLikeFoodQuery();
  const { data: foods } = useGetFoodQuery();
  const [activeTab, setActiveTab] = useState('rooms');

  const userId = user?.id || user?.user?.id;

  const favoriteFoods = useMemo(() => {
    const likedFoodIds = (foodLikes || [])
      .filter((like) => Number(like?.user_liked) === Number(userId))
      .map((like) => like.food);

    return (foods || []).filter((food) => likedFoodIds.includes(food.id));
  }, [foodLikes, foods, userId]);

  const favoriteRooms = useMemo(() => {
    const likedRoomIds = (rooms?.ser_room_likes || [])
      .filter((like) => Number(like?.user_liked) === Number(userId))
      .map((like) => like.room);

    return (rooms?.ser_data || []).filter((room) => likedRoomIds.includes(room.id));
  }, [rooms, userId]);

  return (
    <section className="bg-surface py-12 sm:py-16">
      <div className="section-shell">
        <div className="mx-auto mb-10 max-w-3xl text-center">
          <span className="eyebrow">Saved collection</span>
          <h1 className="section-title mt-5">Your favorites</h1>
          <p className="section-copy mx-auto">Revisit saved rooms and dishes whenever you are ready to book.</p>
        </div>

        <div className="mx-auto mb-8 flex w-full max-w-md rounded-full bg-white p-1 shadow-sm">
          <button type="button" onClick={() => setActiveTab('rooms')} className={`flex-1 rounded-full px-4 py-3 text-sm font-black transition ${activeTab === 'rooms' ? 'bg-gotrip-700  shadow-sm' : 'text-muted hover:text-ink'}`}>Rooms</button>
          <button type="button" onClick={() => setActiveTab('foods')} className={`flex-1 rounded-full px-4 py-3 text-sm font-black transition ${activeTab === 'foods' ? 'bg-gotrip-700  shadow-sm' : 'text-muted hover:text-ink'}`}>Foods</button>
        </div>

        {activeTab === 'rooms' && (
          <Room recordsbool={false} data={{ ser_data: favoriteRooms, ser_room_likes: rooms?.ser_room_likes || [], ser_room_rating: rooms?.ser_room_rating || [] }} user={user}>
            <div>
              <span className="eyebrow">Saved stays</span>
              <h2 className="section-title mt-5">{favoriteRooms.length} favorite room{favoriteRooms.length === 1 ? '' : 's'}</h2>
              <p className="section-copy mx-auto">Your selected rooms are ready for quick booking.</p>
            </div>
          </Room>
        )}

        {activeTab === 'foods' && (
          <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
            {favoriteFoods.map((food) => (
              <Food key={food.id} food={food} user={user} condition={false} />
            ))}
          </div>
        )}

        {((activeTab === 'rooms' && favoriteRooms.length === 0) || (activeTab === 'foods' && favoriteFoods.length === 0)) && (
          <div className="premium-card p-10 text-center">
            <h2 className="section-title">Nothing saved yet</h2>
            <p className="section-copy mx-auto">Save rooms or dishes to build your personal GoTrip shortlist.</p>
          </div>
        )}
      </div>
    </section>
  );
}

export default Favorites;
